import { Component, OnInit, Inject, EventEmitter, Input } from "@angular/core";
import { Subscription, Observable } from "rxjs";
import {
  MatDialogRef,
  MatDialog,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { FormControl, FormBuilder } from "@angular/forms";

@Component({
  selector: "app-search-dialog",
  templateUrl: "./search-dialog.component.html",
  styleUrls: ["./search-dialog.component.scss"],
})
export class SearchDialogComponent implements OnInit {
  searchFunction = new EventEmitter();
  @Input() closeDialog = new EventEmitter();

  adminAreas: Observable<string>;
  roleIds: any = [];
  private form: FormBuilder;
  formsControl = new FormControl();
  subs: Subscription[] = [];
  list: any;
  selected: any;
  public searched$: Observable<any> = null;

  constructor(
    public dialogRef: MatDialogRef<SearchDialogComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public formData
  ) {}

  ngOnInit(): void {}

  get title() {
    if (this.formData.id) {
      return "Search";
    } else {
      return "Search";
    }
  }

  searchData() {
    this.formData.area = this.selected;

    this.searchFunction.emit(this.formData);
    this.close();
  }
  close() {
    this.dialogRef.close();
    this.formData = {};
  }

  selectedArea(data) {
    this.selected = data;
    this.formData.adminAreaId = data.id;
  }
}
